import { useLocation, useNavigate } from "react-router-dom";
import React, { useEffect, useState, useRef } from "react";
import { Button, Col, Container, Form, InputGroup, Row, Card, Badge } from "react-bootstrap";
import PhoneInput from "../../Components/PhoneInput/PhoneInput";
import useApi from "../../Hooks/useApi";
import * as api from "../../api/getapi";
import * as postapi from "../../api/postapi";
import { FiPackage, FiUser, FiCreditCard, FiTruck, FiClipboard, FiSearch, FiX, FiArrowLeft, FiPlusCircle, FiMinus, FiPlus, FiUploadCloud, FiCheckCircle } from "react-icons/fi";
import { isValidUrl } from "../../Utilities/url";
import "./CreateOrder.css";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import SearchableSelect from "../../Components/SearchableSelect";
import LoaderOverlay from "../../Components/Loader/loaderOverlay";

function CreateOrder() {
  const { user } = useSelector((state) => state.auth);

  const getListingCustomDeliveryAmount = (listing) => {
    const possibleAmounts = [listing?.custom_delivery_amount, listing?.custom_delivery_charge, listing?.custom_delivery_charges, listing?.delivery_charge_amount, listing?.delivery_charges];
    return possibleAmounts.find((value) => value !== undefined && value !== null && value !== "");
  };

  const hasListingCustomDelivery = (listing) => listing?.has_custom_delivery === 1 || getListingCustomDeliveryAmount(listing) !== undefined;

  const [error, setError] = useState("");
  const [formValidated, setFormValidated] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  /* cutomer details */
  const [customerInput, setCustomerInput] = useState({
    name: "",
    phone: "",
    email: "",
    address: "",
    nearLandmark: "",
    postalCode: "",
    city: null,
    province: null,
  });

  /* END of cutomer details */

  /* city dropdown */
  const dropdownProvince = useApi(api.getProvinces, { hasCatchError: true });
  const [provinceOptionsData, setProvinceOptionsData] = useState([]);
  const [provinceOptions, setProvinceOptions] = useState([]);
  const [isProvinceLoading, setIsProvinceLoading] = useState(false);
  const getProvinces = async () => {
    setIsProvinceLoading(true);
    dropdownProvince
      .request()
      .then((res) => {
        const getData = res?.data?.map((cat) => ({
          value: cat.province_id,
          label: cat.province_name,
        }));
        setIsProvinceLoading(false);
        setProvinceOptions(getData);
        setProvinceOptionsData(getData);
      })
      .catch((err) => {
        setIsProvinceLoading(false);
        console.error("err" + err);
      });
  };
  useEffect(() => {
    getProvinces();
  }, []);
  const handleProvinceChange = (e) => {
    setCustomerInput((prev) => ({ ...prev, province: e, city: null }));
    setCityOptions([]);
  };

  const dropdownCity = useApi(api.getCities, { hasCatchError: true });
  // const dropdownCity = useApi(api.fetchActiveDeliveryCities, { hasCatchError: true });
  const [cityOptions, setCityOptions] = useState([]);
  const [deliveryCharges, setDeliveryCharges] = useState(0);
  const [itemShippingCharges, setItemShippingCharges] = useState({});
  const [loadingDeliveryCharges, setLoadingDeliveryCharges] = useState(false);
  const [isCitiesLoading, setIsCitiesLoading] = useState(false);
  const [isFreeShipping, setIsFreeShipping] = useState(false);

  const [deliveryType, setDeliveryType] = useState("Standard Delivery");
  const [customDeliveryCharge, setCustomDeliveryCharge] = useState("");
  const [isCustomDeliveryFocused, setIsCustomDeliveryFocused] = useState(false);
  const handleDeliveryTypeChange = (e) => {
    setDeliveryType(e.target.value);
    if (e.target.value === "Standard Delivery") {
      setCustomDeliveryCharge("");
      setIsCustomDeliveryFocused(false);
    } else {
      setIsFreeShipping(false);
    }
  };
  const handleCustomDeliveryChange = (e) => {
    const value = e.target.value;
    if (value === "" || /^\d*\.?\d*$/.test(value)) {
      setCustomDeliveryCharge(value);
    }
  };

  const getCities = async (id) => {
    setIsCitiesLoading(true);
    dropdownCity
      .request(id)
      .then((res) => {
        const getData = res?.data?.map((cat) => ({
          value: cat.city_id,
          label: cat.city_name,
        }));
        setIsCitiesLoading(false);
        setCityOptions(getData);
      })
      .catch((err) => {
        setIsCitiesLoading(false);
        console.error("err" + err);
      });
  };

  useEffect(() => {
    if (customerInput?.province?.value) {
      getCities(customerInput?.province?.value);
    }
  }, [customerInput?.province]);

  const handleCityChange = (e) => {
    setCustomerInput((prev) => ({ ...prev, city: e }));
  };
  /* END of city dropdown */

  /* Fetch Listing states and handlers */

  const [listingFetchInput, setListingFetchInput] = useState("");
  const [listingFetchInputID, setListingFetchInputID] = useState("");
  const [listingFetchInputError, setListingFetchInputError] = useState("");
  const [fetchedListings, setFetchedListings] = useState([]);
  const fetchListingForOrder = useApi(api.fetchListing, { hasCatchError: true });

  const handleListingFetchInput = (e) => {
    setListingFetchInputError("");
    setListingFetchInput(e.target.value);

    if (!isNaN(e.target.value)) {
      // ID
      setListingFetchInputID(e.target.value);
    } else {
      if (isValidUrl(e.target.value)) {
        const urlArray = e.target.value.split("-");
        const id = urlArray[urlArray.length - 1];
        if (!isNaN(id)) {
          setListingFetchInputID(id);
        } else {
          setListingFetchInputError("Please Enter a valid Link");
        }
      } else {
        setListingFetchInputError("Please Enter Listing ID or a valid Link");
      }
    }
  };
  const handleFetchListing = async () => {
    try {
      if (listingFetchInputID?.length > 0) {
        const res = await fetchListingForOrder.request(listingFetchInputID);
        const newListing = res?.data?.data;

        // Check if listing already exists
        const exists = fetchedListings.some((item) => item.listing?.listing_id === newListing?.listing?.listing_id);
        if (exists) {
          setListingFetchInputError("This product has already been added");
          return;
        }

        setFetchedListings((prev) => [...prev, { ...newListing, quantity: 1 }]);
        setListingFetchInput("");
        setListingFetchInputID("");
      } else {
        setListingFetchInputError("Please Enter Listing ID or a valid Link");
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        setListingFetchInputError(error?.response?.data?.message);
      } else {
        setListingFetchInputError(error?.message);
      }
    }
  };

  /* IF we get listing in URL */
  useEffect(() => {
    if (location?.state?.listingData) {
      setFetchedListings([{ ...location?.state?.listingData, quantity: 1 }]);
    }
  }, [location?.state?.listingData]);

  /* END of Fetch Listing states and handlers */

  const hasCustomDeliveryProduct = fetchedListings.some((item) => hasListingCustomDelivery(item?.listing));

  useEffect(() => {
    if (hasCustomDeliveryProduct && deliveryType === "Custom Delivery") {
      setDeliveryType("Standard Delivery");
      setCustomDeliveryCharge("");
      setIsCustomDeliveryFocused(false);
    }
  }, [hasCustomDeliveryProduct, deliveryType]);

  /* payment Radio */
  const [paymentType, setPaymentType] = useState("Cash on Delivery");
  const handlePaymentTypeChange = (e) => {
    setPaymentType(e.target.value);
    if (e.target.value !== "Cash on Delivery") {
      setAdvancePayment("");
    }
  };
  /* END of payment Radio */

  /* Advance Payment & Receipt */
  const [advancePayment, setAdvancePayment] = useState("");
  const [trxProof, setTrxProof] = useState("");
  const [isUploading, setIsUploading] = useState(false);
  const [uploadedReceipt, setUploadedReceipt] = useState(null);
  const fileInputRef = useRef(null);

  const handleReceiptUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!file.type.startsWith("image/")) {
      toast.error("Please upload an image file.", { position: toast.POSITION.BOTTOM_RIGHT, className: "toastMsg" });
      return;
    }
    if (file.size > 10 * 1024 * 1024) {
      toast.error("Maximum file size is 10MB.", { position: toast.POSITION.BOTTOM_RIGHT, className: "toastMsg" });
      return;
    }
    setIsUploading(true);
    try {
      const formData = new FormData();
      formData.append("receipt", file);
      const res = await fetch(`${process.env.REACT_APP_URL_IMAGE_CDN}/images/marketplace/trx-proof`, {
        method: "POST",
        body: formData,
      });
      if (!res.ok) throw new Error("Upload failed");
      const data = await res.json();
      setUploadedReceipt(data.files[0]);
      setTrxProof(data.files[0]);
      toast.success("Receipt uploaded!", { position: toast.POSITION.BOTTOM_RIGHT, className: "toastMsg" });
    } catch (err) {
      toast.error("Failed to upload receipt.", { position: toast.POSITION.BOTTOM_RIGHT, className: "toastMsg" });
    } finally {
      setIsUploading(false);
    }
  };

  const handleRemoveReceipt = () => {
    setUploadedReceipt(null);
    setTrxProof("");
    if (fileInputRef.current) fileInputRef.current.value = "";
  };
  /* END of Advance Payment & Receipt */

  /* Delivery Charges */
  const deliveryChargesApi = useApi(api.CalculateDeliveryCharges, { hasCatchError: true });
  const fetchDeliveryCharges = async ({ cityId, items }) => {
    try {
      setLoadingDeliveryCharges(true);
      const payload = {
        destination_city_id: cityId,
        items: items.map((item) => ({
          quantity: item.quantity,
          unit_price: item.listing?.effective_price,
          listing_id: item.listing?.listing_id,
          shop_id: item.shop?.shop_id,
        })),
      };
      const res = await deliveryChargesApi.request(payload);
      if (res?.data) {
        setDeliveryCharges(+res?.data?.totalShippingCharges || 0);
        const shippingChargesMap = {};
        res?.data?.shops?.forEach((shop) => {
          shop?.categories?.forEach((category) => {
            category?.items?.forEach((item) => {
              if (item?.listingId) {
                shippingChargesMap[item.listingId] = item?.lineShippingCharge ?? 0;
              }
            });
          });
        });
        setItemShippingCharges(shippingChargesMap);
        setLoadingDeliveryCharges(false);
      }
    } catch (error) {
      setLoadingDeliveryCharges(false);
      setDeliveryCharges(null);
      setItemShippingCharges({});
      console.error(error?.response?.data?.message);
    }
  };

  useEffect(() => {
    if (customerInput?.city && fetchedListings.length > 0) {
      fetchDeliveryCharges({
        cityId: customerInput?.city?.value,
        items: fetchedListings,
      });
    }
  }, [fetchedListings, customerInput?.city]);

  const [orderHandledBy, setOrderHandledBy] = useState(null);

  const [formSubmitting, setFormSubmitting] = useState(false);

  const createOrderAPI = useApi(postapi.createD4uOrder, { hasCatchError: true });

  const handleOrderSubmit = async (e) => {
    try {
      e.preventDefault();
      setFormValidated(true);
      setFormSubmitting(true);
      // const form = e.target;
      // console.log(form.checkValidity());

      if (formSubmitting) {
        toast.error(`This order is already in progress wait for the response.`, { position: toast.POSITION.BOTTOM_RIGHT, className: "toastMsg" });

        return;
      }

      if (fetchedListings.length === 0) {
        toast.error(`Please add at least one product to proceed the order.`, { position: toast.POSITION.BOTTOM_RIGHT, className: "toastMsg" });
        return;
      }
      const requiredCustomerFields = ["name", "phone", "email", "address", "postalCode", "city", "province"];
      if (requiredCustomerFields.some((key) => !customerInput?.[key] || customerInput?.[key] === "")) {
        toast.error(`Please enter customer information to proceed the order.`, { position: toast.POSITION.BOTTOM_RIGHT, className: "toastMsg" });
        return;
      }

      if (loadingDeliveryCharges) {
        toast.error(`Please wait while we fetch delivery charges.`, { position: toast.POSITION.BOTTOM_RIGHT, className: "toastMsg" });
        return;
      }
      if (!isFreeShipping && !deliveryCharges) {
        if (customerInput?.city && fetchedListings.length > 0) {
          toast.error(`There is no delivery charges saved against ${customerInput?.city?.label}.`, { position: toast.POSITION.BOTTOM_RIGHT, className: "toastMsg" });
        } else {
          toast.error(`Delivery Charges not set.`, { position: toast.POSITION.BOTTOM_RIGHT, className: "toastMsg" });
        }
        return;
      }
      if (deliveryType === "Custom Delivery") {
        if (customDeliveryCharge === "" || +customDeliveryCharge < 0) {
          toast.error(`Please enter a valid custom delivery charge.`, { position: toast.POSITION.BOTTOM_RIGHT, className: "toastMsg" });
          return;
        }
      }

      if (!orderHandledBy) {
        toast.error(`Please fill Order handled by field.`, { position: toast.POSITION.BOTTOM_RIGHT, className: "toastMsg" });
        return;
      }

      if (customerInput?.postalCode?.length !== 5) {
        toast.error(`Please enter valid postal code.`, { position: toast.POSITION.BOTTOM_RIGHT, className: "toastMsg" });
        return;
      }

      if (paymentType === "Bank Transfer" && !trxProof) {
        toast.error(`Please upload the payment receipt for Bank Transfer.`, { position: toast.POSITION.BOTTOM_RIGHT, className: "toastMsg" });
        return;
      }

      if (paymentType === "Cash on Delivery" && Number(advancePayment || 0) > 0 && !trxProof) {
        toast.error(`Please upload the payment receipt for the advance amount.`, { position: toast.POSITION.BOTTOM_RIGHT, className: "toastMsg" });
        return;
      }

      // Calculate total price for all products
      const productsTotal = fetchedListings.reduce((sum, item) => sum + item.quantity * item.listing?.effective_price, 0);

      const shippingTotal = isFreeShipping ? 0 : deliveryType === "Custom Delivery" ? +customDeliveryCharge : deliveryCharges;
      const totalItems = fetchedListings.length;
      const customDeliveryTotal = Number(customDeliveryCharge);

      let remainingDelivery = shippingTotal;

      const basePerItemDelivery = !isFreeShipping && deliveryType === "Custom Delivery" && totalItems > 0 ? Number((customDeliveryTotal / totalItems).toFixed(2)) : 0;

      const advanceAmount = paymentType === "Bank Transfer" ? productsTotal + (isNaN(shippingTotal) ? 0 : shippingTotal) : Number(advancePayment || 0);

      const data = {
        items: fetchedListings.map((item, index) => {
          const isLastItem = index === totalItems - 1;

          let deliveryCharge = 0;

          if (!isFreeShipping) {
            if (deliveryType === "Custom Delivery") {
              deliveryCharge = isLastItem ? Number(remainingDelivery.toFixed(2)) : basePerItemDelivery;

              remainingDelivery -= deliveryCharge;
            } else {
              deliveryCharge = itemShippingCharges?.[item.listing?.listing_id] ?? 0;
            }
          }

          return {
            quantity: item.quantity,
            unit_price: item.listing?.effective_price,
            listing_id: item.listing?.listing_id,
            shop_id: item.shop?.shop_id,
            delivery_charges: deliveryCharge,
          };
        }),
        delivery_address: {
          name: customerInput?.name,
          email: customerInput?.email,
          contact: customerInput?.phone,
          street_address: customerInput?.address,
          near_landmark: customerInput?.nearLandmark || "",
          city: customerInput?.city?.label,
          country: "Pakistan",
          province: customerInput?.province?.label,
          // postal_code: customerInput?.postalCode
        },
        payment_method: paymentType === "Bank Transfer" ? "Bank" : "COD",
        delivery_charge_amount: shippingTotal,
        is_free_shipping: isFreeShipping,
        amount_receivable: productsTotal + shippingTotal,
        advance_payment: advanceAmount,
        trx_proof: trxProof || null,
        managed_by: orderHandledBy?.value,
      };

      const res = await createOrderAPI.request(data);
      if (res) {
        toast.success(`Order Created Successfully`, { position: toast.POSITION.BOTTOM_RIGHT, className: "toastMsg" });

        navigate("/orders");
      }
    } catch (error) {
      // set error here
      if (error?.response?.data?.message) {
        setError(error?.response?.data?.message);
      } else {
        setError(error?.message);
      }
    } finally {
      setFormSubmitting(false);
    }
  };

  const renderCardTitle = (icon, title, badge) => (
    <h6 className="co-card-title">
      <span className="co-card-icon">{icon}</span>
      {title}
      {badge != null && badge > 0 && <Badge className="co-card-badge" pill>{badge}</Badge>}
    </h6>
  );

  const productsTotal = fetchedListings.reduce((sum, item) => sum + item.quantity * (item.listing?.effective_price ?? 0), 0);
  const shippingTotal = isFreeShipping ? 0 : deliveryType === "Custom Delivery" ? +customDeliveryCharge : deliveryCharges;
  const grandTotal = productsTotal + (isNaN(shippingTotal) ? 0 : shippingTotal);
  const currentAdvance = paymentType === "Bank Transfer" ? grandTotal : Number(advancePayment || 0);
  const remainingCod = Math.max(0, grandTotal - currentAdvance);

  return (
    <>
      <LoaderOverlay loading={formSubmitting} />
      <Container fluid>
        <button type="button" className="co-back-link" onClick={() => navigate("/orders")}>
          <FiArrowLeft aria-hidden="true" /> Back to Orders
        </button>
        <div className="co-page-header">
          <div className="co-page-identity">
            <span className="co-page-icon">
              <FiPlusCircle aria-hidden="true" />
            </span>
            <h1 className="co-page-title">Create Order</h1>
            <span className="co-page-subtitle">Add products and customer details to place a new order</span>
          </div>
        </div>

        <Form noValidate validated={formValidated} onSubmit={handleOrderSubmit}>
          {error && <div className="text-danger mb-3" style={{ fontSize: "0.875rem" }}>*{error}</div>}

          {/* Section 1: Products */}
          <Card className="border-0 shadow-sm mb-3 co-card">
            <Card.Body className="p-4">
              {renderCardTitle(<FiPackage />, "Products", fetchedListings.length)}
              <Form.Group className="mb-3">
                <Form.Label className="co-form-label">Link / Listing ID <span className="co-required">*</span></Form.Label>
                <InputGroup>
                  <InputGroup.Text><FiSearch /></InputGroup.Text>
                  <Form.Control placeholder="Enter Listing ID or Link..." value={listingFetchInput} onChange={handleListingFetchInput} onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); handleFetchListing(); } }} />
                  <Button variant="primary" onClick={handleFetchListing}>Add Product</Button>
                </InputGroup>
                {listingFetchInputError?.length > 0 && <div className="text-danger mt-1" style={{ fontSize: "0.8rem" }}>*{listingFetchInputError}</div>}
                {!(listingFetchInputError?.length > 0) && formValidated && fetchedListings.length === 0 && <div className="text-danger mt-1" style={{ fontSize: "0.8rem" }}>*Please Add At Least One Product</div>}
              </Form.Group>
              {fetchedListings.length > 0 ? (
                <div className="d-flex flex-column gap-2">
                  {fetchedListings.map((item, index) => (
                    <div key={index} className="co-product-card">
                      <img className="co-product-img" alt={item?.listing?.listing_title} src={`${process.env.REACT_APP_URL_S3}/${item?.listing?.img0}`} />
                      <div className="co-product-info">
                        <div className="co-product-title">{item?.listing?.listing_title}</div>
                        <div className="co-product-price">Rs. {item?.listing?.effective_price}</div>
                        {(hasListingCustomDelivery(item?.listing) || item?.listing?.has_free_shipping === 1) && (
                          <div className="mt-1">
                            {hasListingCustomDelivery(item?.listing) && (
                              <Badge bg="warning" text="dark" className="me-1">
                                Custom Delivery{getListingCustomDeliveryAmount(item?.listing) !== undefined ? ` - Rs. ${getListingCustomDeliveryAmount(item?.listing)}` : ""}
                              </Badge>
                            )}
                            {item?.listing?.has_free_shipping === 1 && <Badge bg="success">Free Delivery</Badge>}
                          </div>
                        )}
                        <div className="co-qty-controls">
                          <button type="button" className="co-qty-btn" onClick={() => setFetchedListings((prev) => prev.map((p, i) => (i === index && p.quantity > 1 ? { ...p, quantity: p.quantity - 1 } : p)))}>
                            <FiMinus size={14} />
                          </button>
                          <Form.Control type="number" className="co-qty-input" min={1} value={item.quantity} readOnly />
                          <button type="button" className="co-qty-btn" onClick={() => setFetchedListings((prev) => prev.map((p, i) => (i === index ? { ...p, quantity: p.quantity + 1 } : p)))}>
                            <FiPlus size={14} />
                          </button>
                        </div>
                      </div>
                      <button type="button" className="co-product-remove" onClick={() => setFetchedListings((prev) => prev.filter((_, i) => i !== index))}>
                        <FiX />
                      </button>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="co-empty-hint">Search and add products to include in this order</div>
              )}
            </Card.Body>
          </Card>

          {/* Section 2: Customer Details */}
          <Card className="border-0 shadow-sm mb-3 co-card">
            <Card.Body className="p-4">
              {renderCardTitle(<FiUser />, "Customer Details")}
              <Row className="g-3">
                <Col md={6}><Form.Group><Form.Label className="co-form-label">Name <span className="co-required">*</span></Form.Label><Form.Control value={customerInput?.name} type="text" placeholder="i.e. John Doe" onChange={(e) => setCustomerInput((prev) => ({ ...prev, name: e.target.value }))} required /><Form.Control.Feedback type="invalid">Please Enter Customer Name</Form.Control.Feedback></Form.Group></Col>
                <Col md={6}><Form.Group><Form.Label className="co-form-label">Email <span className="co-required">*</span></Form.Label><Form.Control value={customerInput?.email} type="email" maxLength={64} placeholder="i.e. abc@xyz.com" onChange={(e) => setCustomerInput((prev) => ({ ...prev, email: e.target.value }))} required /><Form.Control.Feedback type="invalid">Please Enter Customer Email</Form.Control.Feedback></Form.Group></Col>
                <Col md={12}><Form.Group><Form.Label className="co-form-label">Address <span className="co-required">*</span></Form.Label><Form.Control value={customerInput?.address} type="text" maxLength={100} placeholder="i.e. House no. X, Street ABC" onChange={(e) => setCustomerInput((prev) => ({ ...prev, address: e.target.value }))} required /><Form.Control.Feedback type="invalid">Please Enter Customer Address</Form.Control.Feedback><Form.Text className="text-muted" style={{ fontSize: "0.72rem" }}>{(customerInput?.address || "").length}/100 characters</Form.Text></Form.Group></Col>
                <Col md={6}><Form.Group><Form.Label className="co-form-label">Nearest Landmark</Form.Label><Form.Control value={customerInput?.nearLandmark} type="text" maxLength={100} placeholder="i.e. Near XYZ Market" onChange={(e) => setCustomerInput((prev) => ({ ...prev, nearLandmark: e.target.value }))} /></Form.Group></Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label className="co-form-label">Province <span className="co-required">*</span></Form.Label>
                    <SearchableSelect placeholder="Select Province" value={customerInput?.province} searchable={true} options={provinceOptions} isClearable={true} handleChange={handleProvinceChange} onInputChange={(newInput) => { if (!newInput) { setProvinceOptions(provinceOptionsData); } else { setProvinceOptions(provinceOptionsData.filter((option) => option.label.toLowerCase().includes(newInput.toLowerCase()))); } return newInput; }} isLoading={isProvinceLoading} />
                    <Form.Control className="p-2" name="province" hidden type="text" value={customerInput?.province ? customerInput?.province?.value : null} onChange={() => {}} required />
                    <Form.Control.Feedback type="invalid">* Please Select Province</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label className="co-form-label">City <span className="co-required">*</span></Form.Label>
                    <SearchableSelect placeholder="Select City" value={customerInput?.city} searchable={true} options={cityOptions} isClearable={true} handleChange={handleCityChange} disabled={!customerInput?.province} isLoading={isCitiesLoading} />
                    <Form.Control className="p-2" name="city" hidden type="text" value={customerInput?.city ? customerInput?.city?.value : null} onChange={() => {}} required />
                    <Form.Control.Feedback type="invalid">* Please Select City</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label className="co-form-label">Postal Code <span className="co-required">*</span></Form.Label>
                    <Form.Control value={customerInput?.postalCode} type="text" placeholder="i.e. 54000" maxLength={5} onBeforeInput={(event) => { const input = event.data; if (input && !/[0-9]/.test(input)) { event.preventDefault(); } }} onChange={(e) => { setCustomerInput((prev) => ({ ...prev, postalCode: e.target.value })); }} onPaste={(e) => { const pasteData = (e.clipboardData || window.clipboardData).getData("text").replace(/[^0-9]/g, ""); if (pasteData.length > 5) { setCustomerInput((prev) => ({ ...prev, postalCode: pasteData.slice(0, 5) })); } else { setCustomerInput((prev) => ({ ...prev, postalCode: pasteData })); } e.preventDefault(); }} isInvalid={formValidated && customerInput?.postalCode?.length !== 5} required />
                    <Form.Control.Feedback type="invalid">Please Enter 5 digit Postal Code</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label className="co-form-label">Phone Number <span className="co-required">*</span></Form.Label>
                    <PhoneInput className="p-2" type="number" placeholder="+92-3XX-XXXXXXX" value={customerInput?.phone} onChange={(e) => setCustomerInput((prev) => ({ ...prev, phone: e.target.value }))} pattern="^((\\+92)|(0092))-{0,1}\\d{3}-{0,1}\\d{7}$|^\\d{11}$|^\\d{4}-\\d{7}$" required isInvalid={formValidated && !/^\+92-\d{3}-\d{7}$/.test(customerInput?.phone || "")} />
                    <Form.Control.Feedback type="invalid">* Please Enter Correct Phone Number</Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
            </Card.Body>
          </Card>

          {/* Section 3: Payment & Delivery */}
          <Card className="border-0 shadow-sm mb-3 co-card">
            <Card.Body className="p-4">
              {renderCardTitle(<FiCreditCard />, "Payment & Delivery")}
              <Row className="g-3">
                <Col md={6}>
                  <Form.Label className="co-form-label">Payment Method</Form.Label>
                  <div className="co-radio-group">
                    <label className="co-radio-card">
                      <Form.Check type="radio" value="Cash on Delivery" onChange={handlePaymentTypeChange} checked={paymentType === "Cash on Delivery"} required name="paymentMethod" isValid={formValidated && paymentType === "Cash on Delivery"} className="me-2" />
                      <span className="co-radio-icon"><FiCreditCard /></span>
                      <span className="co-radio-content">Cash on Delivery</span>
                    </label>
                    <label className="co-radio-card">
                      <Form.Check type="radio" value="Bank Transfer" onChange={handlePaymentTypeChange} checked={paymentType === "Bank Transfer"} required name="paymentMethod" isValid={formValidated && paymentType === "Bank Transfer"} className="me-2" />
                      <span className="co-radio-icon"><FiCreditCard /></span>
                      <span className="co-radio-content">Bank Transfer</span>
                    </label>
                  </div>

                  {paymentType === "Cash on Delivery" && (
                    <Form.Group className="mt-3">
                      <Form.Label className="co-form-label">Advance Amount Collected (Optional)</Form.Label>
                      <Form.Control type="number" min={0} max={grandTotal} placeholder="e.g. 1000" value={advancePayment} onChange={(e) => {
                        const val = e.target.value;
                        if (val === "" || (/^\d*\.?\d*$/.test(val) && +val >= 0 && +val <= grandTotal)) {
                          setAdvancePayment(val);
                        }
                      }} />
                      {Number(advancePayment || 0) > 0 && (
                        <Form.Text className="text-muted" style={{ fontSize: "0.72rem" }}>
                          COD will be Rs. {remainingCod} after deducting advance.
                        </Form.Text>
                      )}
                    </Form.Group>
                  )}

                  {paymentType === "Bank Transfer" && (
                    <div className="mt-3 p-3 border rounded" style={{ backgroundColor: "#f8f9fa" }}>
                      <div className="mb-2"><strong>Full Advance Payment: Rs. {grandTotal}</strong></div>
                      <div className="text-muted" style={{ fontSize: "0.8rem" }}>Customer pays 100% in advance. COD will be 0.</div>
                    </div>
                  )}

                  {(paymentType === "Bank Transfer" || (paymentType === "Cash on Delivery" && Number(advancePayment || 0) > 0)) && (
                    <Form.Group className="mt-3">
                      <Form.Label className="co-form-label">
                        Payment Receipt {paymentType === "Bank Transfer" && <span className="co-required">*</span>}
                        {paymentType === "Cash on Delivery" && Number(advancePayment || 0) > 0 && <span className="co-required">*</span>}
                      </Form.Label>
                      <input ref={fileInputRef} type="file" className="d-none" onChange={handleReceiptUpload} accept="image/*" />
                      <div className="d-flex align-items-center gap-2">
                        <Button variant="outline-secondary" type="button" onClick={() => fileInputRef.current?.click()} disabled={isUploading}>
                          {uploadedReceipt ? <><FiCheckCircle className="me-1" /> Receipt Uploaded</> : <><FiUploadCloud className="me-1" /> Upload Receipt</>}
                        </Button>
                        {isUploading && <span className="text-muted" style={{ fontSize: "0.8rem" }}>Uploading...</span>}
                        {uploadedReceipt && (
                          <Button variant="outline-danger" type="button" size="sm" onClick={handleRemoveReceipt}>
                            <FiX /> Remove
                          </Button>
                        )}
                      </div>
                      {uploadedReceipt && (
                        <div className="mt-2">
                          <img src={`${process.env.REACT_APP_URL_S3}/${uploadedReceipt}`} alt="Receipt" style={{ maxWidth: "200px", maxHeight: "150px", borderRadius: "8px", border: "1px solid #dee2e6" }} />
                        </div>
                      )}
                    </Form.Group>
                  )}
                </Col>
                <Col md={6}>
                  <Form.Label className="co-form-label">Delivery Type</Form.Label>
                  <div className="co-radio-group">
                    <label className="co-radio-card">
                      <Form.Check type="radio" value="Standard Delivery" onChange={handleDeliveryTypeChange} checked={deliveryType === "Standard Delivery"} required name="deliveryType" className="me-2" />
                      <span className="co-radio-icon"><FiTruck /></span>
                      <span className="co-radio-content">Standard Delivery</span>
                    </label>
                    <label className="co-radio-card">
                      <Form.Check type="radio" value="Custom Delivery" onChange={handleDeliveryTypeChange} checked={deliveryType === "Custom Delivery"} required name="deliveryType" className="me-2" disabled={hasCustomDeliveryProduct} />
                      <span className="co-radio-icon"><FiTruck /></span>
                      <span className="co-radio-content">Custom Delivery</span>
                    </label>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>

          {/* Section 4: Order Summary */}
          <Card className="border-0 shadow-sm mb-3 co-card">
            <Card.Body className="p-4">
              {renderCardTitle(<FiClipboard />, "Order Summary")}
              <Row className="g-3">
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Check type="checkbox" id="freeShipping" label="Free Shipping" checked={isFreeShipping} onChange={(e) => setIsFreeShipping(e.target.checked)} disabled={deliveryType === "Custom Delivery"} />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label className="co-form-label">Order Handled By <span className="co-required">*</span></Form.Label>
                    <SearchableSelect placeholder="Select" searchable={false} value={orderHandledBy} options={[{ value: "By Techbazaar", label: "By TechBazaar" }, { value: "By Seller", label: "By Seller" }, { value: "By Delivery Partner", label: "By Delivery Partner" }]} handleChange={(e) => setOrderHandledBy(e)} />
                    <Form.Control className="p-2" name="city" hidden type="text" value={orderHandledBy ? orderHandledBy?.value : null} onChange={() => {}} required />
                    <Form.Control.Feedback type="invalid">* Please Select Handled by detail</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <div className="co-summary-table">
                    <div className="co-summary-row"><span className="co-summary-label">Sub Total</span><span className="co-summary-value">{productsTotal} PKR</span></div>
                    <div className="co-summary-row">
                      <span className="co-summary-label">Shipping</span>
                      <span className="co-summary-value">
                        {deliveryType === "Custom Delivery" ? (
                          isCustomDeliveryFocused ? (
                            <Form.Control type="text" placeholder="Enter amount" value={customDeliveryCharge} onChange={handleCustomDeliveryChange} onBlur={() => setIsCustomDeliveryFocused(false)} autoFocus style={{ width: "150px", display: "inline-block" }} />
                          ) : (
                            <span onClick={() => setIsCustomDeliveryFocused(true)} style={{ cursor: "pointer", textDecoration: "underline" }}>
                              {customDeliveryCharge ? `${customDeliveryCharge} PKR` : "Click to enter amount"}
                            </span>
                          )
                        ) : (
                          <span>{isFreeShipping ? 0 : deliveryCharges} PKR</span>
                        )}
                      </span>
                    </div>
                    <div className="co-summary-row"><span className="co-summary-label">Total</span><span className="co-summary-total">{grandTotal} PKR</span></div>
                    {currentAdvance > 0 && (
                      <>
                        <div className="co-summary-row"><span className="co-summary-label">Advance Paid</span><span className="co-summary-value">{currentAdvance} PKR</span></div>
                        <div className="co-summary-row"><span className="co-summary-label">Remaining (COD)</span><span className="co-summary-total">{remainingCod} PKR</span></div>
                      </>
                    )}
                  </div>
                </Col>
              </Row>
              <div className="co-submit-bar">
                <Button variant="light" className="border" onClick={() => navigate("/orders")}>Cancel</Button>
                <Button type="submit" variant="primary" disabled={formSubmitting} className="co-submit-btn">
                  {formSubmitting ? <><span className="spinner-border spinner-border-sm" /> Placing Order...</> : "Place Order"}
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Form>
      </Container>
    </>
  );
}

export default CreateOrder;
